// Lib
import { uniq } from 'lodash/fp';
import { mergeWith, reduce } from 'lodash';

// Utils
import mergeNotificationElementFilterData from './mergeNotificationElementFilterData';
import buildElementFilterDataFromChildren from './buildElementFilterDataFromChildren';
import { ElementFilterData, ElementFilterDataMap, ElementFilterParams } from './elementFilterDataTypes';

export const buildElementFilterData = (args: ElementFilterParams): ElementFilterDataMap | null => {
    const { elementFilter, currentBoardId, currentBoardDeepChildren } = args;

    if (!elementFilter || elementFilter.isEmpty()) return null;

    const data = [buildElementFilterDataFromChildren(args)];

    const result: ElementFilterDataMap = mergeWith({}, ...data, mergeNotificationElementFilterData);

    // Add the currentBoardId if it's not currently in the map
    if (!result[currentBoardId]) {
        result[currentBoardId] = reduce(
            result,
            (acc, elementFilterDataEntry, elementId) => {
                if (currentBoardDeepChildren.has(elementId)) {
                    const actorIds = acc.actorIds || [];
                    const elementFilterActorIds = elementFilterDataEntry.actorIds || [];
                    acc.actorIds = uniq([...actorIds, ...elementFilterActorIds]);
                    acc.changeCount = (acc.changeCount || 0) + 1;
                }

                return acc;
            },
            { elementId: currentBoardId, focus: false, pass: true, actorIds: [], changeCount: 0 } as ElementFilterData,
        );
    }

    return result;
};
